<template>
<div class="chapter">
<div class="inner_page">
<p class="p9"><span class="t12">In Memoriam</span></p>
<p class="p0"><span class="t12">Marcel Pierre Labarthe</span></p>
<p class="p0"><span class="t12">May 1917 – April 2014</span></p>
<p class="p0"><span class="t12">Rest in peace, Dad.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?7f9e7a4b